import PropTypes from "prop-types";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import RuvixxDate from "components/RuvixxDate";
import DescriptionCard from "routes/swoogo/DescriptionCard";
import {
  DetailGrid,
  DetailRow,
  OverviewSkeleton,
  RecordLink,
} from "routes/swoogo/overviewPrimitives";

const SessionOverview = ({ session, isLoading }) => {
  if (isLoading || !session) {
    return <OverviewSkeleton />;
  }

  return (
    <div className="tw:flex tw:w-full tw:max-w-7xl tw:flex-col tw:gap-4">
      <Card>
        <CardHeader>
          <CardTitle>Session</CardTitle>
        </CardHeader>
        <CardContent>
          <DetailGrid>
            <DetailRow label="Name">{session.name}</DetailRow>
            <DetailRow label="Event">
              {session.event_name ? (
                <RecordLink to={`/swoogo/events/${session.event_id}`}>
                  {session.event_name}
                </RecordLink>
              ) : null}
            </DetailRow>
            <DetailRow label="Date">{session.date}</DetailRow>
            <DetailRow label="Start Time">{session.start_time}</DetailRow>
            <DetailRow label="End Time">{session.end_time}</DetailRow>
            <DetailRow label="Time Zone">{session.timezone}</DetailRow>
            <DetailRow label="Capacity">{session.capacity}</DetailRow>
            <DetailRow label="Last Synced">
              {session.last_synced_at ? (
                <RuvixxDate date={session.last_synced_at} />
              ) : null}
            </DetailRow>
          </DetailGrid>
        </CardContent>
      </Card>

      {session.description ? (
        <DescriptionCard description={session.description} />
      ) : null}
    </div>
  );
};

SessionOverview.propTypes = {
  session: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    event_id: PropTypes.number,
    event_name: PropTypes.string,
    date: PropTypes.string,
    start_time: PropTypes.string,
    end_time: PropTypes.string,
    timezone: PropTypes.string,
    capacity: PropTypes.number,
    last_synced_at: PropTypes.string,
    description: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
};

export default SessionOverview;
